import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const ArrowRight24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='m13.314 12.071-4.95-4.95a1 1 0 0 1 1.414-1.414l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95Z' /></svg>);
